<div>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12">
                <h4 class="m-0 titulos later-color">
                    <i
                        *ngIf="descripcionGeneral !== ''"
                        style="font-size: small !important"
                        class="nav-icon fas fas fa-question-circle"
                        data-toggle="modal"
                        data-target="#myModalHeader"></i>
                </h4>
            </div>
            <!--  <div><a class="header-empresa" [routerLink]="['nueva-empresa']">Empresa</a></div> -->
        </div>
    </div>
</div>

<div
    class="modal fade"
    id="myModalHeader"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div
                class="modal-body text-justify"
                style="overflow-y: scroll"
                [innerHTML]="descripcionGeneral"></div>
        </div>
    </div>
</div>
